import React, { useContext } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Login } from "helpers/api";
import { useNavigate } from "react-router-dom";
import { reactLocalStorage } from "reactjs-localstorage";
import { UserContext } from "contexts/UserContext";
import Input from "components/input";
import LoginIcon from "components/icons/loginIcon";
import Button from "components/Button";

const LoginForm = () => {
  const { setUser } = useContext(UserContext);
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("Votre adresse e-mail doit �tre valide (exemple@domain.com)")
        .required("Veuillez renseigner votre adresse e-mail"),
      password: Yup.string().required("Veuillez renseigner votre mot de passe"),
    }),
    onSubmit: (values) => {
      Login({ email: values.email, password: values.password })
        .then((response) => {
          if (response?.success) {
            setUser(response);
            reactLocalStorage.setObject("var", response);
            navigate(response?.user?.role === "admin" ? "/" : "/client");
          }
        })
        .catch((err) => {
          console.log("error");
        });
    },
  });

  return (
    <div className="h-full w-full">
      <form
        className="shadow-2xl w-[600px]  flex flex-col  gap-4 h-[550px] mx-auto mt-28"
        onSubmit={formik.handleSubmit}
      >
        <div className="text-[22px] font-bold mx-auto my-10 ">Connecter</div>
        <div className="w-[600px] flex flex-col items-start  gap-2 px-16">
          <Input
            label="Email"
            value={formik.values.email}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            id="email"
            name="email"
            error={formik.touched.email ? formik.errors.email : ""}
            placeholder="Adresse email"
            iconRight={
              <LoginIcon fill="#111136" width="25px" className="h-8 lg:h-4" />
            }
          />
        </div>

        <div className="w-[600px] flex flex-col items-start gap-2 px-16">
          <Input
            label="Mot de passe"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            id="password"
            name="password"
            type="password"
            placeholder="Mot de passe"
            error={formik.touched.password ? formik.errors.password : ""}
          />
        </div>
        <div className="text-center mx-16 mt-6 ">
          <Button
            variant="primary"
            className="w-full mb-30 2xl:mb-2 lg:mb-5 h-16 py-1.5 rounded-5 hover:bg-green hover:text-white	2xl:h-14 3xl:text-xl sm:text-base 2xl:text-lg  "
          >
            Se connecter
          </Button>
        </div>
      </form>
    </div>
  );
};

export default LoginForm;
